<template>
  <div class="year-selector">
    <template v-for="year in years">
      <button
        :key="year"
        class="year-selector__button"
        :class="{ 'is-active': year === selectedYear }"
        @click="setYear(year)"
      >{{ year }}</button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'YearSelector',

  computed: {
    ...mapState({
      data: (state) => state.rawData.data,
      selectedYear: (state) => state.rawData.year,
    }),

    years() {
      return Object.keys(this.data);
    },
  },

  methods: {
    setYear(year) {
      this.$store.commit('rawData/setYear', year);
    },
  },
};
</script>

<style lang="scss" scoped>
.year-selector {
  display: flex;

  &__button {
    @include font-size(milli);

    align-items: center;
    background: $color-lynch;
    border: 0;
    border-radius: 50%;
    color: $color-white;
    cursor: pointer;
    display: flex;
    height: 42px;
    justify-content: center;
    margin-right: $global-spacing-unit-half;
    width: 42px;

    &:hover, &.is-active {
      background-color: $color-cerulean;
    }

    &:last-child {
      margin-right: 0;
    }

    &:focus {
      outline: 0;
    }
  }
}
</style>
